import styled from 'styled-components';

type Props = {};

export default styled.section<Props>`
  .box-select {
    display: flex;
    margin-bottom: 8px;
    flex-wrap: wrap;
    .ant-form-item {
      margin-bottom: 0px;
      &.input-onsite {
        display: flex;
        align-items: center;
      }
    }
    .ant-checkbox-wrapper {
      display: flex;
      align-items: center;
      .ant-checkbox {
        top: 0px;
      }
    }
  }
  .group-input {
    padding: 0px 24px 16px 24px;
    .ant-form-item {
      flex-direction: row;
      display: flex;
      &.note-field {
        margin-bottom: 0px;
      }
      .ant-form-item-label {
        font-size: 16px;
        letter-spacing: 0;
        line-height: 24px;
        padding-bottom: 0px;
        .ant-form-item-no-colon {
          min-width: 32px;
          margin-right: 24px;
          font-size: 16px;
          letter-spacing: 0;
          line-height: 24px;
        }
      }
    }
    .select-field {
      min-width: 240px;
    }
    .input-checkbox {
      margin-left: 19px;
      .ant-form-item-label {
        padding-right: 0px;
        min-width: 0px;
      }
    }
    .text-area {
      min-height: 94px !important;
      &::placeholder {
        color: rgba(0, 0, 0, 0.5);
      }
    }
  }
  .ant-modal-footer {
    .ant-btn-primary {
      margin-left: 16px !important;
    }
  }
`;
